import React, { useEffect } from "react";
import "../../Assets/Styles/pages/landing.scss";
import Plans from "../../Components/PricingComponents/plans";
import Compare from "../../Components/PricingComponents/compare";
import PriceFeatures from "../../Components/PricingComponents/priceFeatures";
import Questions from "../../Components/FAQComponents/questions";
import ContactUs from "../../Components/ContactUs/ContactUs";
import { useHistory } from "react-router-dom";

const Pricing = () => {
	const history = useHistory();

	const handlePage = (page) => {
		history.push(page);
	};

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<>
			<Plans handlePage={handlePage} />
			<Compare handlePage={handlePage} />
			<PriceFeatures handlePage={handlePage} />
			<Questions property={"pricing"} handlePage={handlePage} />
			<ContactUs handlePage={handlePage} />
		</>
	);
};

export default Pricing;
